<template>
  <div>
    <div v-if="loading">Loading...</div>
    <card v-else class="card" :title="$t('Organizations')">
      <div class="card__right-button">
        <div class="position-relative">
          <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openAdd = true">
            <i class="fas fa-plus" />
          </button>
          <div class="tooltipCustom tooltipCustom--bottom">Create new Company</div>
        </div>
      </div>

      <!--      <CreateCompanyModal @created="updateCompanyList($event)"> </CreateCompanyModal>-->

      <!-- Content Part -->
      <div class="card__content">
        <div v-if="companies.length > 0">
          <div v-for="company in companies" v-bind:key="company.data.company_id" class="">
            <div class="row">
              <div class="col-sm-9 col-md-5 col-xl">
                <p>{{ company.data.name }}</p>
                <a :href="company.data.company_website" target="_blank" rel="noopener noreferrer" class="website">
                  {{ company.data.company_website }}
                </a>
              </div>
              <div class="col-xl">
                <p class="description">{{ company.data.description }}</p>
              </div>
              <div class="col-xl">
                <router-link :to="'/super_user/company/' + company.data.company_id">
                  <p-button type="success" outline icon>
                    <i class="fa fa-edit" />
                  </p-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <p>{{ $t('There_are_no_companies_yet') }}</p>
        </div>
      </div>

      <!-- End Content Part -->
    </card>

    <ModalTemplate
      @submit="updateCompanyList($event)"
      action="addCompany"
      component-name="CreateCompanyModal"
      button-component-name="CreateNewButton"
      :data="{ header: $t('Create_new_company') }"
      :clicked="openAdd"
      @update:field="openAdd = false"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import EditButton from '../../../components/buttons/EditButton';
import CreateCompanyModal from '../../../components/modals/CreateCompanyModal';
import ModalTemplate from '../../../components/modals/ModalTemplate';
export default {
  name: 'CompaniesIndex',
  components: { ModalTemplate, CreateCompanyModal, EditButton },
  props: {
    companies: {},
  },
  data: function () {
    return {
      loading: false,
      openAdd: false,
    };
  },
  methods: {
    updateCompanyList: function (event) {
      this.companies.push(event);
    },
  },
};
</script>

<style scoped></style>
